module.exports = __webpack_public_path__ + "media/press/today_show_bknd-64a32c6f.png";